import * as constants from './constants';

const initialState = {
  loading: false,
  data: [],
  error: null,
};

// eslint-disable-next-line import/prefer-default-export
export const barcodeManufacturersReducer = (state = initialState, action) => {
  switch (action.type) {
  case constants.GET_BARCODE_MANUFACTURERS:
    return { ...state, loading: true };
  case constants.GET_BARCODE_MANUFACTURERS_SUCCESS: {
    return { ...state, loading: false, data: action.payload };
  }
  case constants.GET_BARCODE_MANUFACTURERS_ERROR:
    return { ...state, loading: false, error: action.payload };
  case constants.RESET_BARCODE_MANUFACTURERS:
    return initialState;
  default:
    return state;
  }
};
